import ImageWMS from 'ol/source/ImageWMS'

import { blurredButton } from './controls/mapLayers'
import { materializeToast } from './notifications'
import { getLayerById, map } from './map/tools'
import { ticket_nib_project } from './tokens'

document.getElementById('ortoWMS').addEventListener('change', (event) => {
  if (event.target.checked) {
    getOrtoPhotoProjects();
  } else {
    const select = document.getElementById('ortoPhotoProjects');
    select.disabled = true;
    select.selectedIndex = 0; // or select.value = 'none';
  }
});

const keepFocusOnBtn = (e) => {
  // console.log('Keep focus', e);
  if (e.target.id !== 'wmsUrlField') blurredButton?.focus();
};

document.getElementById('mapLayerSelector').onclick = keepFocusOnBtn;
const orto = document.getElementById('ortoPhotoProjects');
orto.onclick = (event) => event.stopPropagation();
orto.onchange = () => chooseOrtoPhotoProject(orto.value);


export function getOrtoPhotoProjects() {
  // console.log(document.getElementById('ortoWMS').checked);
  if (!document.getElementById('ortoWMS').checked) return;
  // console.log('getOrtoPhotoProjects');
  const selectList = document.getElementById('ortoPhotoProjects');
  selectList.disabled = false;

  const v = map.getView();
  const e = v.calculateExtent(map.getSize());
  const projection = v.getProjection().getCode().split(':')[1];
  const nibUrl = '/nib2?request={"Coordinates":"' +
      e[0] + ',' + e[1] + ';' + e[0] + ',' + e[3] + ';' +
      e[2] + ',' + e[3] + ';' + e[2] + ',' + e[1] +
  '","InputWKID":' + projection + ',"StopOnCover":false}';

  const p = $.ajax({
    type: 'GET',
    url: nibUrl,
    crossDomain: true,
    dataType: 'json'
  });
  p.done(ortoPhotoProjects => {
    const array = ortoPhotoProjects.ProjectList;
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLSelectElement/remove
    const sl = selectList.length;
    for (let i = sl - 1; i > 0; i--) {
      if (i !== selectList.selectedIndex) selectList.remove(i);
      else selectList.options.item(selectList.selectedIndex).hidden = true;
    }
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLSelectElement/add
    const al = array.length;
    for (let i = 0; i < al; i++) {
      const project = array[i];
      // const viewString = (ai.length > 50) ? ai.substr(ai.length - 50) : ai;
      // new Option(text, value, defaultSelected, selected):
      selectList.add(new Option(project.substr(0, 50), project));
      selectList.lastElementChild.onclick = keepFocusOnBtn;
    }
  });
  p.fail(r => {
    // console.log('fail', r.status);
    materializeToast(
      'FlyfotoProsjekter feilet! Kunne ikke hente data fra Norge i Bilder',
      'error'
    );
  });
}

function chooseOrtoPhotoProject(project) {
  const server = 'https://wms.geonorge.no/skwms1/wms.nib-prosjekter';
  getLayerById('ortoWMS').setSource(new ImageWMS({
    url: server + '?ticket=' + ticket_nib_project,
    params: { 'LAYERS': project, 'TRANSPARENT': true, 'VISIBLE': true },
    ratio: 1
  }));
}
